import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ProjectsSideBarItems,
  UserSideBarItems,
} from "components/sidebar/SidebarItems";
import lisapropLogo from "assets/png/LisapropLogo.png";
import logout from "assets/svg/logout.svg";
import { NavLink } from "react-router-dom";
import overviewWhite from "assets/svg/overviewWhite.svg";
import overviewBlack from "assets/svg/overviewBlack.svg";

const AdminSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <aside className="w-[268px] h-[100vh] max-h-[100vh] overflow-y-auto border-r-[1px] border-r-[#CCCCCC] ">
      <button
        type="button"
        onClick={() => navigate("/")}
        className="scrutz-text pt-[24px] pl-[64px] text-[24px] font-nunito font-[700] flex  "
      >
        <img alt="scrutz logo" src={lisapropLogo} className="" />
      </button>
      <div
        className={`${
          location.pathname.split("/")[1] !== "visitor" ? "flex" : "hidden"
        } flex-col mt-10 `}
      >
        <NavLink
          to="/dashboard"
          className={({ isActive }) => (isActive ? "" : "")}
        >
          {({ isActive }) => (
            <button
              className={`  ${
                isActive
                  ? " active-icon rounded-[28px] bg-primary pl-6 h-[40px] font-[500] font-nunito text-[14px] text-white mt-[3%] flex items-center ml-10 w-[70%] "
                  : "inactive-icon w-[70%] h-[40px] font-[500] pl-6 font-nunito text-[14px] text-[#17191C] flex items-center mt-[3%] ml-10 hover:scale-[1.1] transform duration-300 "
              }`}
            >
              <span className="mr-[8px] ">
                {isActive ? (
                  <img src={overviewWhite} alt="Overview Icon" />
                ) : (
                  <img src={overviewBlack} alt="Overview Icon" />
                )}
              </span>
              Overview
            </button>
          )}
        </NavLink>
      </div>
      <div className="flex mb-4 items-center justify-center w-full">
        <p className="text-[#D4D4DA] mt-6 w-[70%] ">USERS</p>
      </div>
      {UserSideBarItems.map((props, index) => {
        return (
          <NavLink
            key={index}
            to={props.to}
            className={({ isActive }) => (isActive ? "" : "")}
          >
            {({ isActive }) => (
              <button
                className={` ${
                  isActive
                    ? " active-icon rounded-[28px] bg-primary pl-6 h-[40px] font-[500] font-nunito text-[14px] text-white mt-[3%] flex items-center ml-10 w-[70%] "
                    : "inactive-icon w-[70%] h-[40px] font-[500] pl-6 font-nunito text-[14px] text-[#17191C] flex items-center mt-[3%] ml-10 hover:scale-[1.1] transform duration-300 "
                }`}
              >
                <span className="mr-[8px] ">
                  {isActive ? props.icon : props.icon2}
                </span>
                {props.title}
              </button>
            )}
          </NavLink>
        );
      })}

      <div className="flex mb-4 items-center justify-center w-full">
        <p className="text-[#D4D4DA] mt-6 w-[70%] ">PROJECTS</p>
      </div>
      {ProjectsSideBarItems.map((props, index) => {
        return (
          <NavLink
            key={index}
            to={props.to}
            className={({ isActive }) => (isActive ? "" : "")}
          >
            {({ isActive }) => (
              <button
                className={` ${
                  isActive
                    ? " active-icon rounded-[28px] bg-primary pl-6 h-[40px] font-[500] font-nunito text-[14px] text-white mt-[3%] flex items-center ml-10 w-[70%] "
                    : "inactive-icon w-[70%] h-[40px] font-[500] pl-6 font-nunito text-[14px] text-[#17191C] flex items-center mt-[3%] ml-10 hover:scale-[1.1] transform duration-300 "
                }`}
              >
                <span className="mr-[8px] ">
                  {isActive ? props.icon : props.icon2}
                </span>
                {props.title}
              </button>
            )}
          </NavLink>
        );
      })}

      <div className="absolute bottom-[64px] left-[64px] ">
        <button
          onClick={() => {
            localStorage.clear();
            navigate("/");
          }}
          className="flex items-center gap-2 text-[#FF3104] "
        >
          <img src={logout} alt="logout" />
          Logout
        </button>
      </div>
    </aside>
  );
};

export default React.memo(AdminSidebar);
